import { Component, Input } from '@angular/core';
import { IconoirCustomFlagSolid, IconoirWhiteFlag } from '@ey-xd/motif-icon';
import { MotifModule } from "@ey-xd/motif-wc-angular"; 

@Component({
  selector: 'app-analysis-warning',
  standalone: true,
  imports: [MotifModule],
  templateUrl: './analysis-warning.component.html',
  styleUrl: './analysis-warning.component.scss',
})
export class AnalysisWarningComponent {
  @Input() flaggedItems: any[] = [];
  @Input() fullData: any[] = [];

  IconoirCustomFlagSolid = IconoirCustomFlagSolid;
  IconoirWhiteFlag = IconoirWhiteFlag;
}
